module.exports = __webpack_public_path__ + "img/development.6e299f5d.svg";